import React from 'react';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';

import Modal from 'react-modal';
import { styledTheme } from 'globalStyles/theme';
import './styles.scss';

const PaymentModal = ({ open, onClose, invoiceId, children, opacity = 1 }) => {
  const onCloseHandler = () => {
    if (onClose)
      onClose();
    else
      window.location.href = `/invoice/view/${invoiceId}`;
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={open}
      contentLabel="PodoModal"
      className="invoice-modal__container"
      shouldCloseOnOverlayClick
      onRequestClose={onClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
          backgroundColor: styledTheme.modalBackground,
        },
        content: {
          opacity,
        },
      }}
    >
      <div
        className="invoice-modal__header"
      >
        <IoClose
          className="invoice-modal__close"
          size={20}
          onClick={onCloseHandler}
        />
      </div>
      <div className="invoice-modal__body">
        {children}
      </div>
    </Modal>
  );
};

PaymentModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

PaymentModal.defaultProps = {
  open: true,
  onClose: () => {},
};

export default PaymentModal;
